import { styled } from '@mui/material/styles';
import { Typography, Paper } from '@mui/material';

const PREFIX = 'BusinessFormInstructions';

const classes = {
  container: `${PREFIX}-container`,
};

const Root = styled(Paper)(({ theme }) => ({
  [`&.${classes.container}`]: {
    backgroundColor: 'rgba(1, 16, 18, 0.04)',
    padding: theme.spacing(2),
    width: 564,
    marginLeft: 12,
    marginRight: 'auto',
    overflowY: 'auto',
  },
}));

export default function BusinessFormInstructions() {
  return (
    <Root className={classes.container}>
      <Typography mt={2} mb={2} variant="h4">
        Support for this page
      </Typography>
      <Typography variant="h6">
        Please provide us with your business information including: Business
        name and DBA, entity type/status, and business location.
      </Typography>
    </Root>
  );
}
